import "core-js";
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.common";
import reportWebVitals from "./reportWebVitals";
import { BrowserCryptoService, cryptoProvider } from "@blacknut/javascript-sdk/dist";

cryptoProvider.service = new BrowserCryptoService();

const root = createRoot(document.getElementById("root") as HTMLElement);
root.render(<App />);

const qs = new URLSearchParams(window.location.search);
const clearDataFromQuery = qs.get("cd");
if (clearDataFromQuery) {
  localStorage.clear();
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
if (process.env.REACT_APP_REPORT_WEB_VITALS) {
  reportWebVitals(console.log);
}
